import React from 'react';
import styles from './Footer.module.css';
import classNames from 'classnames';

const MyFooter = () => {
    return (
        <footer className={styles.footer}>
            <section className={styles.firstSection}>
                <div className={styles.firstBlock}>
                    <a href="mailto:sekretariat@npi.cz" className={classNames(styles.firstBlockLink, styles.linkTransparent)}><img className={styles.firstBlockLinkImage} alt="ico message" width="50" height="50" src="https://www.npi.cz/images/template/ico_message.svg" /><span>&nbsp;sekretariát@npi.cz</span></a>
                    <a href="mailto:michal.kriz@npi.cz" className={classNames(styles.firstBlockLink, styles.linkBlue)}><img className={styles.firstBlockLinkImage} alt="ico question" width="33" height="33" src="https://www.npi.cz/images/template/ico_question.svg" /><span>&nbsp;uvítáme zpětnou vazbu</span></a>
                </div>

                <div className={styles.secondBlock}>
                    <section className={styles.listBlock}>
                        <h3>Důležité odkazy</h3>
                        <ul className={styles.list}>
                            <li className={styles.list}><a href="https://www.npi.cz/projekty/4604-spolecne-vzdelavani-a-podpora-skol-krok-za-krokem">Projekt APIV A</a></li>
                            <li className={styles.list}><a href="https://www.npi.cz/volna-mista">Kariéra</a></li>
                        </ul>
                    </section>
                    <section className={styles.listBlock}>
                        <h3>Weby NPI</h3>
                        <ul className={styles.list}>
                            <li className={styles.list}><a href="https://kc.rvp.cz/">Konzultační centrum NPI</a></li>
                            <li className={styles.list}><a href="https://www.edu.cz/">EDU.cz</a></li>
                            <li className={styles.list}><a href="https://rvp.cz/">Metodický portál RVP.CZ</a></li>
                            <li className={styles.list}><a href="https://www.infoabsolvent.cz/">Infoabsolvent</a></li>
                        </ul>
                    </section>
                    <section className={styles.listBlock}>
                        <h3>Sociální sítě</h3>
                        <ul className={styles.list}>
                            <li className={styles.list}><a href="https://www.facebook.com/narodnipedagogickyinstitut">Facebook</a></li>
                            <li className={styles.list}><a href="https://www.youtube.com/channel/UCzx0HUrvq48ZPtKvqIrKJAg/videos">YouTube</a></li>
                            <li className={styles.list}><a href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQG3-WcfV6Ld5gAAAYHQNmY4vQrRuvA1seEDXKM9JzCQJPRX-7MABrCE2B7hnL7RbjM_Zpp-mrt3dltyU5_BWdWxRs1ycj2lXqr38PHezjFUWITxjjXvKc2N7fUWda4ift8tuYM=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F18120513%2Fadmin%2F">LinkedIn</a></li>
                            <li className={styles.list}><a href="https://twitter.com/NPI_CR">Twitter</a></li>
                        </ul>
                    </section>
                    <section className={styles.listBlock}>
                        <h3 className={styles.contactHeading}>Kontakt</h3>
                        <p>Senovážné náměstí 25,<br />110 00 Praha<br /><a className={classNames(styles.secondBlockLink, styles.beforeElement)} href="https://mapy.cz/s/2lfKH" target="_blank" rel="noopener noreferrer">Zobrazit na mapě</a></p>
                        <p><strong>Telefon: </strong>222 122 112<br />
                            <strong>Fax: </strong>224 228 334<br />
                            <strong>E-mail: </strong><a className={styles.secondBlockLink} href="mailto:sekretariat@npi.cz">sekretariat@npi.cz</a>
                        </p>
                    </section>
                </div>
            </section>
            <section className={styles.thirdSection}>
                <section className={styles.imgWrapper}>
                    <img src="https://www.npi.cz/images/template/Logolink_OP_VVV_hor_barva_cz%201.jpg" alt="Vlajka Evropské unie" width={618} height={137} />
                </section>
                <section>
                    <p className={styles.thirdSectionParagraph}>
                        Národní pedagogický institut České republiky 2023
                    </p>
                </section>
            </section>
        </footer>
    )
}

export default MyFooter;